import { Component, OnInit } from '@angular/core';
import { ShoopingService } from '../shooping.service';
import { Products } from '../shooping.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';
import {MatButtonModule} from '@angular/material/button';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  products: Products[] = [];
  favProduct = [];
  toppings = new FormControl();
  sortType: string;
  sortList: string[] = ['Ascending', 'Desecding'];
  searchModel: string;

  constructor(private shoopingService: ShoopingService, private spinnerService: NgxSpinnerService, private notifyService : NotificationService) { }

  ngOnInit(): void {
    this.showSpinner();
    this.fetchProducts();
    this.getFavProducts();
  }

  fetchProducts() {
    this.shoopingService.getProducts().subscribe(res => {
      res.forEach(item => item.price = Math.floor(item.price));
      this.products = res;
    });
  }

  sortProduct(e) {
    console.log('hello' +e);
    let sortType;
    if(e == 'Ascending' ){
      sortType = 'asc';
    } else {
      sortType = 'desc';
    }
    this.shoopingService.sortProducts(sortType).subscribe(res => {
      this.products = res;
    })
  }

  getFavProducts() {
    this.favProduct = JSON.parse(localStorage.getItem('favProduct'));
  }

  updateSearchModel(value) {
    this.searchModel = value;
  }

  public showSpinner(): void {
    this.spinnerService.show();
    if(this.products.length > 0){
      this.spinnerService.hide();
    }
  }

  addFavourite(product){
    this.checkFavourite(product);
    localStorage.setItem('favProduct', JSON.stringify(this.favProduct));
  }

  showToasterSuccess(message){
    this.notifyService.openSnackBar(message);
  }

  checkFavourite(product) {
    let findProduct = this.favProduct.some(item => item.id == product.id)
    if(!findProduct) {
      this.favProduct.push(product);
      this.showToasterSuccess('Product added in the Favourite List!');
    } else {
      let removeProduct = this.favProduct.filter(item => item.id !== product.id);
      this.favProduct = removeProduct;
      this.showToasterSuccess('Product removed in the Favourite List!');
    }
  }
}
